// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__34TjD","title":"InfoRow_title__90NG8"};